/**
 * 事件日志面板
 * 显示游戏事件流
 */

export interface LogEntry {
  time: string;
  message: string;
}

export class LogPanel {
  private container: HTMLElement;
  private entries: LogEntry[] = [];
  private maxEntries: number = 100;

  constructor(containerId: string) {
    const el = document.getElementById(containerId);
    if (!el) throw new Error(`Element #${containerId} not found`);
    this.container = el;
    this.container.className = 'panel';
    this.render();
  }

  /** 添加一条日志 */
  add(message: string): void {
    if (!message) return;

    const now = new Date();
    const time = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

    this.entries.push({ time, message });

    // 限制日志数量
    if (this.entries.length > this.maxEntries) {
      this.entries = this.entries.slice(-this.maxEntries);
    }

    this.render();
  }

  /** 清空日志 */
  clear(): void {
    this.entries = [];
    this.render();
  }

  render(): void {
    if (this.entries.length === 0) {
      this.container.innerHTML =
        '<div class="panel-title">📜 修仙日志</div><div style="color:var(--text-secondary); text-align:center; padding:20px; opacity:0.5;">修仙之路由此开始...</div>';
      return;
    }

    let html = '<div class="panel-title">📜 修仙日志</div>';

    // 最近 30 条，倒序显示（最新在上）
    const recent = this.entries.slice(-30).reverse();
    for (const entry of recent) {
      html += `<div class="log-entry"><span class="log-time">${entry.time}</span>${escapeHtml(entry.message)}</div>`;
    }

    this.container.innerHTML = html;
  }
}

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
